import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cross",
  "use": "cross-usage",
  "viewBox": "0 0 10 11",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 11\" id=\"cross\"><path d=\"M8.02.1 5.4 4.54 2.8.1H.86l3.52 5.46L.86 11h1.93L5.4 6.77 8.02 11h1.93L6.48 5.55 9.95.09H8.02Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol